export default __webpack_public_path__ + "static/media/health_check_En.9163e23c.webp";